export class CreatePurchaseOrderMessage {
  customerId?: number
  description: string
  setACalendarDate: string
  supplierId: number
  venderPoNumber: string

  orderPartIds: number[]

  constructor(customerId: number|undefined, description: string, setACalendarDate: string, supplierId: number, venderPoNumber: string, orderPartIds: number[]) {
    this.customerId = customerId
    this.description = description
    this.setACalendarDate = setACalendarDate
    this.supplierId = supplierId
    this.venderPoNumber = venderPoNumber
    this.orderPartIds = orderPartIds
  }
}
